export default {
    setOrdersTime: (state, param) => {
        const {payload} = param;
        return state.data = payload;
    },
}
